import { useEffect } from "react";

import { PHOTO_STAGES } from "../constants";
import useVehiclePhotos from "./useVehiclePhotos";

export default function useHandoverPhotos({
  bookingId,
  facilityId,
  valetSessionId,
}) {
  const handover = useVehiclePhotos({
    bookingId,
    facilityId,
    stage: PHOTO_STAGES.HANDOVER,
    valetSessionId,
  });

  const { reset } = handover;

  useEffect(() => {
    reset();
  }, [bookingId, valetSessionId, reset]);

  return handover;
}
